import {MDCTextField} from '@material/textfield';

export function init(): void {
	document.querySelectorAll('.mdc-text-field').forEach(el => new MDCTextField(el));
}
